export const SHOW_CONFIRM_MODAL = "SHOW_CONFIRM_MODAL";
export const HIDE_CONFIRM_MODAL = "HIDE_CONFIRM_MODAL";